// extracted by mini-css-extract-plugin
module.exports = {"reaction":"Reaction_reaction__Z7AHY","count":"Reaction_count__12pck","emoji":"Reaction_emoji__1SeLP","active":"Reaction_active__3eCIL"};